import { useSWRConfig } from "swr";
import React, { useState } from "react";
import FormModal from "../common/FormModal";
import { Form } from "react-bulma-components";
import { fetcher } from "../utils/fetch";

export default function AddInspirationForm({ onClose, project, show }) {
    const { mutate } = useSWRConfig();

    const [url, setUrl] = useState();

    const onSubmit = async () => {
        try {
            await fetcher(`/api/projects/${ project.id }/inspiration`, {
                method: 'POST',
                body: JSON.stringify({
                    url: url
                })
            });

            await mutate(`/api/projects/${ project.id }`);
        } catch (e) {
            // TODO: Check for validation errors
            // TODO: Check for catastrophic failures
            console.error('oops', e);
        }

        onClose();
    };


    return (
        <FormModal title="Add inspiration" onSubmit={ onSubmit } onClose={ onClose } show={ show }>
            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>URL</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input type="url" onChange={ e => setUrl(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>
        </FormModal>
    )
}